function copyFromHash () {
  var hash = window.location.hash;
  var params = new URLSearchParams(hash.replace("#", "?"));

  if (params.has("copy")) {
    var copy = params.get("copy");
    var message = params.get("message") || "Code wurde in die Zwischenablage kopiert!";
    const errorMessage = params.get("error-message") || "Leider konnte der Code nicht in die Zwischenablage kopiert werden.";

    navigator.clipboard.writeText(copy).then(
      function () {
        CeresNotification.success(message).closeAfter(3000);
      },
      function () {
        CeresNotification.error(errorMessage).closeAfter(3000);
      }
    );
  }
}

(function () {
  const id = setInterval(function () {
    if (window.CeresNotification) {
      clearInterval(id);
      copyFromHash();
    }
  }, 100);
})();
window.addEventListener("hashchange", copyFromHash);
